import { useGetInvoiceTotals } from '@cocoonspace/sdk-js/domains/invoices/invoices'
import type { InvoiceTotalsMonths } from '@cocoonspace/sdk-js/types/invoiceTotalsMonths'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'
import { Price } from '~/components/price'

import { useTracking } from '~/providers/tracking-provider'

import { DashboardCard } from './dashboard-card'

type InvoiceMonths = keyof InvoiceTotalsMonths

export const DashboardInvoiceCard = () => {
	const { t } = useTranslation()
	const { track } = useTracking()

	const { data: invoicesTotal, isLoading } = useGetInvoiceTotals({
		year: new Date().getFullYear(),
	})

	const totalMonthInvoiceAmount = useMemo(() => {
		if (!invoicesTotal?.data.months) return 0

		const currentMonth = new Date().getMonth()

		return invoicesTotal?.data.months[currentMonth as unknown as InvoiceMonths]
	}, [invoicesTotal?.data.months])

	return (
		<DashboardCard
			isLoading={isLoading}
			title={t('cwDashboard:invoices.title') as string}
			subtitle={t('cwDashboard:invoices.subtitle') as string}
			link={{
				label: t('cwDashboard:invoices.linkLabel'),
				href: '/my-account/invoices',
				onClick: () => track.click('dashboard-seeInvoices-link'),
			}}
		>
			<Price
				price={totalMonthInvoiceAmount}
				className='font-bold text-6xl text-primary leading-none'
			/>
		</DashboardCard>
	)
}
